import React from "react";
import { Fade } from "react-awesome-reveal";
import Header from "parts/Header";
import Footer from "parts/Footer";
import Button from "elements/Button";
import photo1 from "../assets/images/IMG_2612.jpg";
import photo2 from "../assets/images/IMG_2616.jpg";

const WHY_CHOOSE_US = [
  {
    title: "Custom Solutions",
    description:
      "We offer flexibility in flavors and packaging, providing both bulk solutions and ready-to-shelf bottled products.",
  },
  {
    title: "Quality Ingredients",
    description:
      "Our commitment to quality starts with sourcing the finest ingredients and maintaining rigorous standards in every product.",
  },
  {
    title: "B2B Expertise",
    description:
      "With years of experience in food manufacturing, we understand the unique demands of B2B clients and aim to exceed expectations with every order.",
  },
];

const FOUNDERS = [
  { photo: photo1, name: "Swati Raut", role: "Co-Founder" },
  { photo: photo2, name: "Niket Raut", role: "Co-Founder" },
];

const AboutPage = () => (
  <main className="min-h-screen">
    <Header />

    <section className="py-16">
      <div className="container mx-auto px-4">
        <Fade direction="up" triggerOnce>
          <p className="mb-2 text-center text-sm font-semibold uppercase tracking-widest text-gold-700">
            About Us
          </p>
          <h1 className="mx-auto max-w-3xl text-center font-display text-4xl text-maroon-900 sm:text-5xl">
            Our Mission
          </h1>
          <p className="mx-auto mt-4 max-w-2xl text-center text-lg font-light text-slate-500">
            Bringing flavor and convenience to the food industry by delivering high-quality
            sauces and condiments, backed by reliable service and innovative packaging solutions.
          </p>
        </Fade>

        <Fade direction="up" triggerOnce>
          <h2 className="mt-20 text-center font-display text-3xl text-maroon-900">Why Choose Us</h2>
          <div className="mx-auto mt-10 grid max-w-5xl grid-cols-1 gap-6 sm:grid-cols-3">
            {WHY_CHOOSE_US.map((item) => (
              <div key={item.title} className="rounded-2xl border border-slate-100 bg-white p-6 shadow-sm">
                <h3 className="font-display text-xl text-maroon-800">{item.title}</h3>
                <p className="mt-2 text-slate-500">{item.description}</p>
              </div>
            ))}
          </div>
        </Fade>

        <Fade direction="up" triggerOnce>
          <h2 className="mt-24 text-center font-display text-3xl text-maroon-900">Meet Our Co-Founders</h2>
          <div className="mx-auto mt-10 flex max-w-3xl flex-col justify-center gap-10 sm:flex-row">
            {FOUNDERS.map((founder) => (
              <div key={founder.name} className="text-center">
                <img
                  src={founder.photo}
                  alt={founder.name}
                  loading="lazy"
                  className="mx-auto h-48 w-48 rounded-full border-4 border-gold-100 object-cover shadow-lg sm:h-56 sm:w-56"
                />
                <p className="mt-4 font-display text-xl text-slate-800">{founder.name}</p>
                <p className="text-slate-400">{founder.role}</p>
              </div>
            ))}
          </div>
        </Fade>

        <Fade direction="up" triggerOnce>
          <div className="mx-auto mt-24 max-w-2xl rounded-2xl bg-maroon-50 p-10 text-center">
            <h2 className="font-display text-3xl text-maroon-900">Join Us</h2>
            <p className="mt-3 text-lg text-slate-500">
              Partner with us to bring exceptional sauces and condiments to your business, and
              let us help you serve the best to your customers.
            </p>
            <Button
              href="/contact-us"
              type="link"
              className="mt-6 inline-flex rounded-full bg-maroon-700 px-8 py-3 font-semibold text-white transition-colors hover:bg-maroon-800"
            >
              Get in Touch
            </Button>
          </div>
        </Fade>
      </div>
    </section>

    <Footer />
  </main>
);

export default AboutPage;
